export default {
  clientId: 'ID de Cliente',
  reviewedSummaries: 'Resúmenes Revisados',
  summaryId: 'ID de Resumen',
  user: 'Usuario',
  vote: 'Voto',
  comment: 'Comentario',
  timestamp: 'Fecha y hora'
}
